import { Component, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { DevanManagementService } from '../../../../../../../shared/Container/devan/devan-management.service';
import { DevanType } from '../../../../../../../shared/Container/devan/models/DevanType';
import { CommonModule } from '@angular/common';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CustomDateRangePickerComponent } from '../../../../../../../shared/components/custom-date-range-picker/custom-date-range-picker.component';

@Component({
  selector: 'app-container-job-devan-properties',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgSelectModule, CustomDateRangePickerComponent],
  templateUrl: './container-job-devan-properties.component.html',
  styleUrl: './container-job-devan-properties.component.scss'
})
export class ContainerJobDevanPropertiesComponent {
  @Input()
  formGroup!: FormGroup;

  // Lookups
  availableDevanTypes$: Observable<DevanType[]>;

  constructor(private devanManagementService: DevanManagementService) {
    this.availableDevanTypes$ = this.devanManagementService.getDevanType(true, true);
  }

    getFormPartial = (formPath: string) => this.formGroup.get(formPath) as FormControl;


  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup']) {
      this.formGroup.patchValue(changes['formGroup'], { emitEvent: false });
    }
  }
}
